module.exports = __webpack_public_path__ + "img/column_yuwen2.20302f03.png";